import React from "react";
import "./navbar.scss";
import { useState } from "react";

const Navbar = () => {
  const [activeTab, setActiveTab] = useState("offer"); // Default active tab

  const navItem = [
    {
      tabName: "Offers",
      key: "offer",
    },
    {
      tabName: "Photos",
      key: "photo",
    },
    {
      tabName: "Menus",
      key: "menu",
    },
    // {
    //   tabName: "Reviews",
    //   key: "review",
    // },
    {
      tabName: "About",
      key: "about",
    },
  ];
  return (
    <div className="navbar-section">
      {navItem?.map((item, index) => {
        return (
          // <div className="nav-item" key={index}>
          //   <a className="nav-link" href={`#${item.key}`}>
          //     {item.tabName}
          //   </a>
          // </div>
             <div
               className={`nav-item ${
                 activeTab === item.key ? "active" : ""
               }`}
               key={index}
               onClick={() => setActiveTab(item.key)}
             >
               <a className="nav-link" href={`#${item.key}`}>
                 {item.tabName}
               </a>
             </div>
        );
      })}
    </div>
  );
};

export default Navbar;
